import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Typography } from '@raisin/components-lib';

export const GridContainer = styled(Grid)(({ theme }) => ({
  justifyContent: 'center',
  maxWidth: 320,
  marginTop: theme.spacing(6),
}));

export const Card = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: theme.spacing(80),
  padding: theme.spacing(8),
  margin: theme.spacing(7.5, 0, 0, 8),
  backgroundColor: theme.palette.blue10.main,
  borderRadius: 8,

  [theme.breakpoints.down('lg')]: {
    width: '100%',
    margin: theme.spacing(6, 0, 11),
  },
}));

export const InterestRate = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  color: theme.palette.blue80.main,

  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.h2.fontSize,
    lineHeight: theme.typography.h3.lineHeight,
  },
}));

export const SubText = styled(Typography)(({ theme }) => ({
  color: theme.palette.blue80.main,
  textAlign: 'center',

  [theme.breakpoints.down('lg')]: {
    fontWeight: theme.typography.subtitle1.fontWeight,
  },
}));

export const SubTextHeader = styled(SubText)(({ theme }) => ({
  color: theme.palette.black80.main,
}));
